import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useDeviationViewContext } from '../../../Context';
import DesktopDeviationPage from '../../DesktopDeviationPage';
import FullscreenDeviationPage from '../../FullscreenDeviationPage';
import MobileDeviationPage from '../../MobileDeviationPage';
import { getDeviationType, isLegacyStatus } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import SimplePage from '../SimplePage';
import DesktopTextualPage from '../../DesktopTextualPage';
import DesktopStatusPage from '../../DesktopStatusPage';
import MobileTierPage from '../../MobileTierPage';
import DesktopTierPage from '../../DesktopTierPage';
const DeviationPageContent = ({ deviation })=>{
    const isMobile = useContext(MobileContext);
    const { isFullscreen } = useDeviationViewContext();
    const deviationType = getDeviationType(deviation);
    if (isMobile) {
        switch(deviationType){
            case DeviationTypes.TIER:
                return /*#__PURE__*/ React.createElement(MobileTierPage, {
                    deviation: deviation
                });
            case DeviationTypes.COMMISSION:
                return /*#__PURE__*/ React.createElement(MobileDeviationPage, {
                    deviation: deviation,
                    withoutSidebar: true
                });
            default:
                return /*#__PURE__*/ React.createElement(MobileDeviationPage, {
                    deviation: deviation
                });
        }
    }
    if (isFullscreen) {
        return /*#__PURE__*/ React.createElement(FullscreenDeviationPage, {
            deviation: deviation
        });
    }
    switch(deviationType){
        case DeviationTypes.COMMISSION:
            return /*#__PURE__*/ React.createElement(SimplePage, {
                deviation: deviation,
                withoutSidebar: true
            });
        case DeviationTypes.STATUS:
            if (!isLegacyStatus(deviation)) {
                return /*#__PURE__*/ React.createElement(DesktopStatusPage, {
                    deviation: deviation
                });
            }
            return /*#__PURE__*/ React.createElement(SimplePage, {
                deviation: deviation
            });
        case DeviationTypes.POLL:
            return /*#__PURE__*/ React.createElement(SimplePage, {
                deviation: deviation
            });
        case DeviationTypes.JOURNAL:
        case DeviationTypes.LITERATURE:
            return /*#__PURE__*/ React.createElement(DesktopTextualPage, {
                deviation: deviation
            });
        case DeviationTypes.TIER:
            return /*#__PURE__*/ React.createElement(DesktopTierPage, {
                deviation: deviation
            });
        default:
            return /*#__PURE__*/ React.createElement(DesktopDeviationPage, {
                deviation: deviation
            });
    }
};
DeviationPageContent.displayName = 'DeviationPageContent';
export default DeviationPageContent;
